import React from 'react'
import { BackgroundSpec } from '~/models'
import { memo } from '~/ui/component'
import { Label, HBox, SelectField, SelectFieldProps } from '~/ui/components'
import { Choice } from '~/ui/components/fields/SelectField'
import { layout } from '~/ui/styling'
import { useBranding } from '../BrandingContext'
import BrandingBackgroundSwatch from './BrandingBackgroundSwatch'

export type Props = Omit<SelectFieldProps<string>, 'choices'>

const BrandingBackgroundField = memo('BrandingBackgroundField', (props: Props) => {

  const {branding} = useBranding()

  //------
  // Rendering

  function render() {
    return (
      <SelectField
        {...props}
        choices={choices}
      />
    )
  }

  const renderNamedBackground = React.useCallback((name: string, spec: BackgroundSpec, list: boolean) => {
    return (
      <HBox padding={list ? layout.padding.inline.m : 0} gap={layout.padding.inline.m}>
        <BrandingBackgroundSwatch name={name}/>
        <Label flex mono>
          {name}
        </Label>
      </HBox>
    )
  }, [])

  const choices = React.useMemo((): Choice<string>[] => {
    return Object.entries(branding?.backgrounds ?? {}).map(([name, spec]) => ({
      value:  name,
      render: list => renderNamedBackground(name, spec, list),
    }))
  }, [branding?.backgrounds, renderNamedBackground])

  return render()

})

export default BrandingBackgroundField